import { axiosInstance, useUtilities } from "helpers";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { getTemplateTasks } from "redux/reducers/templateLibrary/tasks";

export async function getAllTasks() {
  return axiosInstance
    .post("defaulttaskshow", {
      api_key: localStorage.getItem("apikey"),
      parent_type: "task",
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function deleteTask(id) {
  return axiosInstance
    .post(`defaulttaskdelete`, {
      api_key: localStorage.getItem("apikey"),
      id: id,
    })
    .then((res) => ({ ...res.data, id }))
    .catch((err) => err);
}

export async function updateTask({ title, tags, id, ...rest }) {
  return axiosInstance
    .post(`defaulttaskedit`, {
      api_key: localStorage.getItem("apikey"),
      title: title,
      id: id,
      tags: tags,
      ...rest,
    })
    .then((res) => res.data)
    .catch((err) => err);
}

export async function addTask(data) {
  return axiosInstance
    .post(`addlibrarytemplate`, {
      ...data,
      api_key: localStorage.getItem("apikey"),
      parent_type: "task",
      module_hint: "task",
      wpsl_tem: localStorage.getItem("apikey"),
    })
    .then((res) => res.data)
    .catch((err) => new Error(err));
}

export async function getWpslTasks() {
  return axiosInstance
    .post("getwpsltasktemp", {
      api_key: localStorage.getItem("apikey"),
      parent_type: "task",
    })
    .then((res) => res.data)
    .catch((err) => new Error(err));
}
export async function addTemplateTask(data) {
  return axiosInstance
    .post("adddefaulttemplate", {
      api_key: localStorage.getItem("apikey"),
      ...data,
    })
    .then((res) => res.data)
    .catch((err) => new Error(err));
}

export function removeDefaultTask(id) {
  return axiosInstance
    .post("defaulttaskremove", {
      api_key: localStorage.getItem("apikey"),
      id,
    })
    .then((res) => ({ ...res.data, id }))
    .catch((err) => new Error(err));
}

export function useGetWpslTasks() {
  return useQuery(["wpslTasksList"], getWpslTasks);
}

export function useGetTasks() {
  return useQuery(["tasksList"], getAllTasks);
}

export function useTasks() {
  const { data, isLoading, error } = useGetTasks();
  const {
    dispatch,
    siteTasks: { tasks, loaded },
  } = useUtilities();

  useEffect(() => {
    if (loaded) return;
    if (data) {
      dispatch(getTemplateTasks(data.data));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loaded]);
  return { data: tasks, isLoading: isLoading || !loaded, error };
}
